import { PROPOSAL_STATUS } from './proposal-status.model';

// HR
export enum HR_PROPOSAL_STEP {
  BORROWER_SIGNATURE_PENDING = 'BORROWER_SIGNATURE_PENDING',
  UNDER_ANALYSIS = 'UNDER_ANALYSIS',
  REGISTRATION_PENDING = 'REGISTRATION_PENDING',
  INVOICE_PENDING = 'INVOICE_PENDING',
  CREDIT_PENDING = 'CREDIT_PENDING',
  CREDIT_ERROR = 'CREDIT_ERROR',
  CREDITED = 'CREDITED',
  DENIED = 'DENIED',
  CANCELING = 'CANCELING',
  CANCELED = 'CANCELED',
  FINISHED = 'FINISHED',
  EXPIRED = 'EXPIRED',
  PENDING_PAYMENT = 'PENDING_PAYMENT',
}

export type HrProposalStatusByStepMap = { [property in HR_PROPOSAL_STEP]: PROPOSAL_STATUS[] };

export const HR_PROPOSAL_STATUS_BY_STEP: HrProposalStatusByStepMap = {
  BORROWER_SIGNATURE_PENDING: [PROPOSAL_STATUS.BORROWER_SIGNATURE_PENDING],
  UNDER_ANALYSIS: [
    PROPOSAL_STATUS.LENDER_SIGNATURE_PENDING,
    PROPOSAL_STATUS.LENDER_APPROVAL_PENDING,
    PROPOSAL_STATUS.FINISHED_PENDING,
    PROPOSAL_STATUS.RELEASED,
  ],
  REGISTRATION_PENDING: [PROPOSAL_STATUS.REGISTRATION_PENDING],
  INVOICE_PENDING: [PROPOSAL_STATUS.DEBT_TRANSFER_INVOICE_PENDING],
  CREDIT_PENDING: [
    PROPOSAL_STATUS.CNAB_PENDING,
    PROPOSAL_STATUS.CREDIT_PENDING,
    PROPOSAL_STATUS.ENDORSEMENT_CREATED,
  ],
  CREDIT_ERROR: [PROPOSAL_STATUS.CREDIT_ERROR],
  CREDITED: [PROPOSAL_STATUS.IN_PROGRESS],
  DENIED: [PROPOSAL_STATUS.DENIED],
  CANCELING: [PROPOSAL_STATUS.CANCELING_PENDING],
  CANCELED: [PROPOSAL_STATUS.CANCELED],
  FINISHED: [PROPOSAL_STATUS.FINISHED],
  EXPIRED: [PROPOSAL_STATUS.EXPIRED],
  PENDING_PAYMENT: [PROPOSAL_STATUS.DEFAULT],
};

// EMPLOYEE
export enum EMPLOYEE_PROPOSAL_STEP {
  SIGNATURE_PENDING = 'SIGNATURE_PENDING',
  UNDER_ANALYSIS = 'UNDER_ANALYSIS',
  INVOICE_PENDING = 'INVOICE_PENDING',
  CREDIT_PENDING = 'CREDIT_PENDING',
  CREDIT_ERROR = 'CREDIT_ERROR',
  CREDITED = 'CREDITED',
  DENIED = 'DENIED',
  CANCELING = 'CANCELING',
  CANCELED = 'CANCELED',
  FINISHED = 'FINISHED',
  EXPIRED = 'EXPIRED',
  PENDING_PAYMENT = 'PENDING_PAYMENT',
}

export type EmployeeProposalStatusByStepMap = {
  [property in EMPLOYEE_PROPOSAL_STEP]: PROPOSAL_STATUS[];
};

export const EMPLOYEE_PROPOSAL_STATUS_BY_STEP: EmployeeProposalStatusByStepMap = {
  SIGNATURE_PENDING: [PROPOSAL_STATUS.BORROWER_SIGNATURE_PENDING],
  UNDER_ANALYSIS: [
    PROPOSAL_STATUS.LENDER_SIGNATURE_PENDING,
    PROPOSAL_STATUS.LENDER_APPROVAL_PENDING,
    PROPOSAL_STATUS.REGISTRATION_PENDING,
    PROPOSAL_STATUS.RELEASED,
  ],
  INVOICE_PENDING: [PROPOSAL_STATUS.DEBT_TRANSFER_INVOICE_PENDING],
  CREDIT_PENDING: [
    PROPOSAL_STATUS.CNAB_PENDING,
    PROPOSAL_STATUS.CREDIT_PENDING,
    PROPOSAL_STATUS.ENDORSEMENT_CREATED,
    PROPOSAL_STATUS.FINISHED_PENDING,
  ],
  CREDIT_ERROR: [PROPOSAL_STATUS.CREDIT_ERROR],
  CREDITED: [PROPOSAL_STATUS.IN_PROGRESS],
  DENIED: [PROPOSAL_STATUS.DENIED],
  CANCELING: [PROPOSAL_STATUS.CANCELING_PENDING],
  CANCELED: [PROPOSAL_STATUS.CANCELED],
  FINISHED: [PROPOSAL_STATUS.FINISHED],
  EXPIRED: [PROPOSAL_STATUS.EXPIRED],
  PENDING_PAYMENT: [PROPOSAL_STATUS.DEFAULT],
};
